"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorMessage = void 0;
const react_1 = require("react");
const validator_1 = require("../types/validator");
function useErrorMessage({ componentList_ }, props) {
    const { messageFactory = DEFAULT_ERROR_MESSAGE_FACTORY, customValidator } = props !== null && props !== void 0 ? props : {};
    // 绑定组件
    const componentListRef = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        const componentSub = componentList_.subscribe({
            next: componentList => {
                componentListRef.current = componentList;
            },
        });
        return () => {
            componentSub.unsubscribe();
        };
    }, [componentList_]);
    const realMessageFactory = (0, react_1.useCallback)((entity) => {
        var _a, _b;
        const currentComponent = (_a = componentListRef.current) === null || _a === void 0 ? void 0 : _a.find(component => component.key === entity.paramKey);
        const { label = entity.paramKey } = currentComponent !== null && currentComponent !== void 0 ? currentComponent : {};
        const { options = [] } = (_b = currentComponent) !== null && _b !== void 0 ? _b : {};
        const optionEntity = Object.fromEntries(options.map(({ value, label }) => [value, label]));
        return messageFactory(Object.assign(Object.assign({}, entity), { label, actualText: optionEntity[entity.actual], expectedText: Array.isArray(entity.expected) && options.length
                ? entity.expected.map(e => optionEntity[e])
                : undefined }));
    }, [messageFactory]);
    return {
        messageFactory: realMessageFactory,
        customValidator,
    };
}
exports.useErrorMessage = useErrorMessage;
const DEFAULT_ERROR_MESSAGE_FACTORY = entity => {
    const { operator, actual, expected, label, actualText, expectedText, customText } = entity;
    // 有customText的情况下优先
    if (customText) {
        return customText;
    }
    switch (operator) {
        case validator_1.ErrorMessageOperator.REQUIRED: {
            return `参数【${label}】 是必填项，但是目前为空。`;
        }
        case validator_1.ErrorMessageOperator.IN: {
            return `参数【${label}】 应该在 ${JSON.stringify(expectedText)}之中，但是目前选择了 ${JSON.stringify(actualText !== null && actualText !== void 0 ? actualText : actual)}。`;
        }
        case validator_1.ErrorMessageOperator.NOT_IN: {
            return `参数【${label}】 不应该在 ${JSON.stringify(expectedText)}之中，但是目前选择了${JSON.stringify(actualText !== null && actualText !== void 0 ? actualText : actual)}。`;
        }
        case validator_1.ErrorMessageOperator.BETWEEN: {
            return `参数【${label}】应该在 ${JSON.stringify(expected)}之间，但是目前是 ${JSON.stringify(actual)}`;
        }
        case validator_1.ErrorMessageOperator.MATCH: {
            return `参数【${label}】 应该匹配正则表达式 RegExp(${JSON.stringify(expected)})，但是目前是${JSON.stringify(actual)}`;
        }
        default: {
            return `参数【${label}】当前值为 ${JSON.stringify(actual)} ，不满足校验规则。`;
        }
    }
};
